import { GET_BOOKED_TIME_FAIL, GET_BOOKED_TIME_SUCCESS } from './types';

const initialState = {
	bookedTime: [],
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_BOOKED_TIME_SUCCESS:
			return {
				...state,
				bookedTime: payload,
				loading: false,
			};
		case GET_BOOKED_TIME_FAIL:
			return {
				...state,
				bookedTime: payload,
				loading: false,
			};
		default:
			return state;
	}
}
